export function mergeCustomers(existingCustomers, brondataCustomers) {
    const mergedCustomers = [...existingCustomers];
    for (const brondataCustomer of brondataCustomers) {
        const existingCustomerIndex = mergedCustomers.findIndex((c) => c.id === brondataCustomer.id);
        if (existingCustomerIndex === -1) {
            // Customer not found, add new customer
            mergedCustomers.push(brondataCustomer);
        }
        else {
            // Merge with existing customer
            const existingCustomer = mergedCustomers[existingCustomerIndex];
            if (existingCustomer) {
                mergedCustomers[existingCustomerIndex] = {
                    ...existingCustomer,
                    personDetails: {
                        ...existingCustomer.personDetails,
                        ...brondataCustomer.personDetails,
                    },
                    contactDetails: {
                        ...existingCustomer.contactDetails,
                        ...brondataCustomer.contactDetails,
                    },
                    otherDetails: {
                        ...existingCustomer.otherDetails,
                        ...brondataCustomer.otherDetails,
                    },
                    residence: {
                        ...existingCustomer.residence,
                        ...brondataCustomer.residence,
                    },
                    identification: {
                        ...existingCustomer.identification,
                        ...brondataCustomer.identification,
                    },
                };
            }
        }
    }
    return mergedCustomers;
}
export function mergeIncome(existingIncome, brondataIncome) {
    const mergedByCustomer = [...existingIncome.byCustomer];
    for (const brondataCustomerIncome of brondataIncome.byCustomer ?? []) {
        const existingCustomerIncomeIndex = mergedByCustomer.findIndex((c) => c.customerId === brondataCustomerIncome.customerId);
        if (existingCustomerIncomeIndex === -1) {
            mergedByCustomer.push(brondataCustomerIncome);
        }
        else {
            const existingCustomerIncome = mergedByCustomer[existingCustomerIncomeIndex];
            if (existingCustomerIncome) {
                mergedByCustomer[existingCustomerIncomeIndex] = {
                    ...existingCustomerIncome,
                    sections: {
                        loondienst: [
                            ...(existingCustomerIncome.sections.loondienst ?? []),
                            ...(brondataCustomerIncome.sections.loondienst ?? []),
                        ],
                        pensioen: [
                            ...(existingCustomerIncome.sections.pensioen ?? []),
                            ...(brondataCustomerIncome.sections.pensioen ?? []),
                        ],
                        uitkering: [
                            ...(existingCustomerIncome.sections.uitkering ?? []),
                            ...(brondataCustomerIncome.sections.uitkering ?? []),
                        ],
                        onderneming: [
                            ...(existingCustomerIncome.sections.onderneming ?? []),
                            ...(brondataCustomerIncome.sections.onderneming ?? []),
                        ],
                        ivo: [
                            ...(existingCustomerIncome.sections.ivo ?? []),
                            ...(brondataCustomerIncome.sections.ivo ?? []),
                        ],
                        overig: [
                            ...(existingCustomerIncome.sections.overig ?? []),
                            ...(brondataCustomerIncome.sections.overig ?? []),
                        ],
                    },
                };
            }
        }
    }
    return { byCustomer: mergedByCustomer };
}
export function mergeAssets(existingAssets, brondataAssets) {
    const mergedByCustomer = [...existingAssets.byCustomer];
    for (const brondataCustomerAssets of brondataAssets.byCustomer ?? []) {
        const existingCustomerAssetsIndex = mergedByCustomer.findIndex((c) => c.customerId === brondataCustomerAssets.customerId);
        if (existingCustomerAssetsIndex === -1) {
            mergedByCustomer.push(brondataCustomerAssets);
        }
        else {
            const existingCustomerAssets = mergedByCustomer[existingCustomerAssetsIndex];
            if (existingCustomerAssets) {
                mergedByCustomer[existingCustomerAssetsIndex] = {
                    ...existingCustomerAssets,
                    sections: {
                        savingsAccount: [
                            ...(existingCustomerAssets.sections.savingsAccount ?? []),
                            ...(brondataCustomerAssets.sections.savingsAccount ?? []),
                        ],
                        investmentAccount: [
                            ...(existingCustomerAssets.sections.investmentAccount ?? []),
                            ...(brondataCustomerAssets.sections.investmentAccount ?? []),
                        ],
                        savingsPlan: [
                            ...(existingCustomerAssets.sections.savingsPlan ?? []),
                            ...(brondataCustomerAssets.sections.savingsPlan ?? []),
                        ],
                        other: [
                            ...(existingCustomerAssets.sections.other ?? []),
                            ...(brondataCustomerAssets.sections.other ?? []),
                        ],
                    },
                };
            }
        }
    }
    return { byCustomer: mergedByCustomer };
}
export function mergeLiabilities(existingLiabilities, brondataLiabilities) {
    const mergedByCustomer = [...existingLiabilities.byCustomer];
    for (const brondataCustomerLiabilities of brondataLiabilities.byCustomer ??
        []) {
        const existingCustomerLiabilitiesIndex = mergedByCustomer.findIndex((c) => c.customerId === brondataCustomerLiabilities.customerId);
        if (existingCustomerLiabilitiesIndex === -1) {
            mergedByCustomer.push(brondataCustomerLiabilities);
        }
        else {
            const existingCustomerLiabilities = mergedByCustomer[existingCustomerLiabilitiesIndex];
            if (existingCustomerLiabilities) {
                mergedByCustomer[existingCustomerLiabilitiesIndex] = {
                    ...existingCustomerLiabilities,
                    sections: {
                        overdraftFacility: [
                            ...(existingCustomerLiabilities.sections.overdraftFacility ?? []),
                            ...(brondataCustomerLiabilities.sections.overdraftFacility ?? []),
                        ],
                        revolvingCredit: [
                            ...(existingCustomerLiabilities.sections.revolvingCredit ?? []),
                            ...(brondataCustomerLiabilities.sections.revolvingCredit ?? []),
                        ],
                        personalLoan: [
                            ...(existingCustomerLiabilities.sections.personalLoan ?? []),
                            ...(brondataCustomerLiabilities.sections.personalLoan ?? []),
                        ],
                        privateLease: [
                            ...(existingCustomerLiabilities.sections.privateLease ?? []),
                            ...(brondataCustomerLiabilities.sections.privateLease ?? []),
                        ],
                        studentDebtSF35: [
                            ...(existingCustomerLiabilities.sections.studentDebtSF35 ?? []),
                            ...(brondataCustomerLiabilities.sections.studentDebtSF35 ?? []),
                        ],
                        studentDebtSF15: [
                            ...(existingCustomerLiabilities.sections.studentDebtSF15 ?? []),
                            ...(brondataCustomerLiabilities.sections.studentDebtSF15 ?? []),
                        ],
                        spousalAlimony: [
                            ...(existingCustomerLiabilities.sections.spousalAlimony ?? []),
                            ...(brondataCustomerLiabilities.sections.spousalAlimony ?? []),
                        ],
                    },
                };
            }
        }
    }
    return { byCustomer: mergedByCustomer };
}
